import Vue from "vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import CustomCard from "@/layouts/components/CustomCard";

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component("custom-card", CustomCard);
